export const LIST_USERS_PLUS = 'LIST_USERS_PLUS';

export const GET_GROUPUSERS = 'GET_GROUPUSERS';
export const GET_SHAREDCONTENT = 'GET_SHAREDCONTENT';
export const GET_SHARINGPLUS = 'GET_SHARINGPLUS';
